export default __webpack_public_path__ + "static/media/ic_manage_queue.5623b394.svg";